import { FetchMFAPreferenceOutput, fetchMFAPreference } from "aws-amplify/auth";

import { HttpError } from "@/types/error";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getMfa = async (): Promise<FetchMFAPreferenceOutput> => {
  return fetchMFAPreference();
};

export function useGetMfa(
  queryOptions?: UseQueryOptions<FetchMFAPreferenceOutput, HttpError>,
) {
  return useQuery({
    queryKey: ["mfa"],
    queryFn: () => getMfa(),
    ...queryOptions,
  });
}
